<script setup lang="ts">
import type { Property } from '~/core/entities/property';

import { usePropertyHeroNavigation } from '~/composables/usePropertyHeroNavigation';

import { HoverExpandButton } from '~/components/HoverExpandButton';
import { SearchSuggestSelectModal } from '~/components/SearchSuggestSelectModal';

import IconMaterialSymbolsLightArrowBack from '~icons/material-symbols-light/arrow-back';
import IconMaterialSymbolsLightSearch from '~icons/material-symbols-light/search';

interface PropertyHeroNavigationControlsProps {
	property: Property | null;
}

const props = defineProps<PropertyHeroNavigationControlsProps>();

const propertyRef = computed(() => props.property);

const { backButtonHoverText, handleBackButtonClick, handleSearchBarClick } =
	usePropertyHeroNavigation({
		property: propertyRef
	});

const glassCircleButtonClass =
	'!border !border-white/10 !bg-[rgba(102,102,102,0.3)] backdrop-blur-[6px] hover:[@media(hover:hover)]:!border-white/25 hover:[@media(hover:hover)]:!bg-[rgba(102,102,102,0.5)]';
</script>

<template>
	<div
		class="absolute left-4 top-[4.5rem] z-30 flex gap-3 md:left-5 md:top-[5.5rem] lg:left-12 lg:gap-5"
	>
		<HoverExpandButton
			:class="[glassCircleButtonClass, 'size-10 justify-center lg:hidden']"
			@click="handleBackButtonClick"
		>
			<template #icon>
				<IconMaterialSymbolsLightArrowBack
					class="size-5 text-white group-hover:[@media(hover:hover)]:!text-white"
				/>
			</template>
		</HoverExpandButton>

		<HoverExpandButton
			:class="[
				glassCircleButtonClass,
				'hidden justify-center lg:inline-flex lg:max-h-none lg:min-h-12 lg:min-w-12 lg:max-w-none'
			]"
			@click="handleBackButtonClick"
		>
			<template #icon>
				<IconMaterialSymbolsLightArrowBack
					class="size-5 text-white group-hover:[@media(hover:hover)]:!text-white"
				/>
			</template>
			<template #title>
				<ClientOnly>
					{{ backButtonHoverText }}
				</ClientOnly>
			</template>
		</HoverExpandButton>

		<SearchSuggestSelectModal :property="property">
			<HoverExpandButton
				:class="[glassCircleButtonClass, 'size-10 justify-center lg:size-12']"
				@click="handleSearchBarClick"
			>
				<template #icon>
					<IconMaterialSymbolsLightSearch
						class="size-5 text-white group-hover:[@media(hover:hover)]:!text-white"
					/>
				</template>
			</HoverExpandButton>
		</SearchSuggestSelectModal>
	</div>
</template>
